module.exports = __webpack_public_path__ + "img/file.a697c5be.png";